import { createFileRoute } from '@tanstack/react-router';
import { Typography, Paper, Box, Chip } from '@mui/material';

export const Route = createFileRoute('/projects/$projectId/')({
  component: ProjectDetailsComponent,
});

function ProjectDetailsComponent() {
  const { projectId } = Route.useParams();

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Typography variant='h5' component='h2'>
          Project Details
        </Typography>
        <Chip label={`ID: ${projectId}`} variant='outlined' />
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant='body1' sx={{ mb: 2 }}>
          Project ID: {projectId}
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Project details will be implemented in a future task
        </Typography>
      </Paper>
    </Box>
  );
}
